import {
  TextField,
  Button,
  Box,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Link,
  TableContainer,
  Checkbox,
  InputAdornment,
} from '@mui/material'

import { useEffect, useState } from 'react'
import { linkFrontTickets, searchFrontTickets } from '../../Apis/routes/front'
import { useDebounce } from '../../hooks/useDebounce'
import { CircularProgress } from '@material-ui/core'
import LinkIcon from '@mui/icons-material/Link'

export const FrontTicketSearchTable = ({
  ticketId,
  frontTicketsAlreadyLinked,
  navigateToLinkedView,
}) => {
  const [frontTickets, setFrontTickets] = useState([])
  const [searchQuery, setSearchQuery] = useState('')
  const [ticketsSelected, setTicketsSelected] = useState([])
  const debouncedSearchQuery = useDebounce(searchQuery, 1000)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (debouncedSearchQuery) setIsLoading(true)
    searchFrontTickets(debouncedSearchQuery).then((frontTicketsFetched) => {
      setIsLoading(false)
      if (!frontTicketsFetched?.length) {
        return
      }
      const frontTicketsFiltered = frontTicketsFetched.filter(
        (frontTicket) =>
          !frontTicketsAlreadyLinked.find(
            (frontTicketAlreadyLinked) =>
              frontTicketAlreadyLinked.frontConversation === frontTicket.id
          )
      )
      setFrontTickets(frontTicketsFiltered)
      setTicketsSelected([])
    })
  }, [debouncedSearchQuery])

  const handleClickRow = (ticketSelected) => {
    setTicketsSelected((prevState) => {
      const isAlreadySelected = prevState.find(
        (ticket) => ticket.id === ticketSelected.id
      )
      if (!isAlreadySelected) {
        return [...prevState, ticketSelected]
      } else {
        return prevState.filter((ticket) => ticket.id !== ticketSelected.id)
      }
    })
  }

  const handleClickLinkTickets = async () => {
    await linkFrontTickets(ticketId, ticketsSelected)
    navigateToLinkedView()
  }

  const isSelected = (row) =>
    ticketsSelected.findIndex((ticket) => ticket.id === row.id) !== -1

  return (
    <>
      <TextField
        fullWidth
        variant="outlined"
        placeholder="Demandeur, assigné, email, sujet, id, etc."
        value={searchQuery}
        label="Rechercher"
        sx={{ my: 2 }}
        onChange={(e) => {
          setSearchQuery(e.target.value)
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              {isLoading && <CircularProgress color="inherit" size={20} />}
            </InputAdornment>
          ),
        }}
      />
      {frontTickets.length > 0 && (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell align="left">ID</TableCell>
                <TableCell align="left">Lien</TableCell>
                <TableCell align="left">Sujet</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {frontTickets.map((frontTicket) => {
                const isTicketSelected = isSelected(frontTicket)

                return (
                  <TableRow
                    hover
                    onClick={() => handleClickRow(frontTicket)}
                    role="checkbox"
                    aria-checked={isTicketSelected}
                    tabIndex={-1}
                    key={frontTicket.id}
                    selected={isTicketSelected}
                    sx={{ cursor: 'pointer' }}
                  >
                    <TableCell padding="checkbox">
                      <Checkbox color="primary" checked={isTicketSelected} />
                    </TableCell>
                    <TableCell component="th" scope="row" align="left">
                      {frontTicket.id}
                    </TableCell>
                    <TableCell align="left">
                      <Link
                        href={`https://app.frontapp.com/open/${frontTicket.id}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        https://app.frontapp.com/open/
                        {frontTicket.id}
                      </Link>
                    </TableCell>
                    <TableCell align="left">{frontTicket.subject}</TableCell>
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      <Box
        sx={{
          position: 'sticky',
          bottom: 0,
          backgroundColor: 'background.paper',
          paddingY: 2,
          borderTop: 1,
          borderColor: 'divider',
          zIndex: 1,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={handleClickLinkTickets}
            disabled={ticketsSelected.length === 0}
            size="large"
            startIcon={<LinkIcon />}
          >
            Lier {ticketsSelected.length}
            {ticketsSelected.length > 1
              ? ' conversations'
              : ' conversation'}{' '}
            Front
          </Button>
        </Box>
      </Box>
    </>
  )
}
